import { identity } from 'ramda'
import createSelector from 'selectorator'
import { NAMESPACE } from '../constants'

// const getState = state => state

export const getUnallocatedSuspenseAccountsState = createSelector([NAMESPACE], identity)
